import HorizontalMenu from "components/user/HorizontalBar";
import { useEffect } from "react";
import Listing from "screens/user/Listing";
import { fetchInitialData } from "store/slices/main.slice";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "hooks/store";

type Props = {};

const InventorySetting = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get("product")) {
      dispatch(fetchInitialData(navigate));
    }
  }, [searchParams, dispatch, navigate]);

  return (
    <div className="h-full w-full flex flex-col relative z-0 overflow-hidden">
      <HorizontalMenu />
      <div className="flex-1 overflow-y-auto h-full">
        <Listing />
      </div>
    </div>
  );
};

export default InventorySetting;
